<template>
    <div class="weui-msg">
        <div class="weui-msg__icon-area" v-show="info.icon">
            <i class="weui-icon_msg" :class="'weui-icon-' + info.icon"></i>
        </div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">{{info.title}}</h2>
            <p class="weui-msg__desc">{{info.desc}}</p>
        </div>
        <div class="weui-msg__opr-area">
            <p class="weui-btn-area">
                <span v-for="(btn, index) in info.buttons" :key="index">
                    <router-link v-if="!!btn.route"
                        class="weui-btn" :class="!!btn.primary ? 'weui-btn_primary' : 'weui-btn_default'"
                        :to="btn.route">{{btn.title}}</router-link>

                    <a v-if="btn.route == undefined"
                        class="weui-btn" :class="!!btn.primary ? 'weui-btn_primary' : 'weui-btn_default'"
                        href="javascript:;" @click="onClick(index)">{{btn.title}}</a>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
/**
 * message => [
 *  title
 *  desc
 *  icon
 *  buttons: [
 *      title
 *      route
 *      primary
 *  ]
 * ]
 */
export default {
    name: "Msg",
    props: ["info"],
    methods: {
        onClick(index) {
            this.$emit('click', index);
        }
    }
}
</script>